export const features = [
  {
    feature: "Dashboard",
    configKey: "niramaya.featureaccess.sidebaritem.homepage",
    roles: ["Volunteer Coordinator", "Volunteer"],
  },
  {
    feature: "Announcements",
    configKey: "niramaya.featureaccess.sidebaritem.announcements",
    roles: ["Volunteer Coordinator", "Volunteer"],
  },
  {
    feature: "Journal",
    configKey: "niramaya.featureaccess.sidebaritem.journal",
    roles: ["Volunteer Coordinator", "Volunteer"],
  },
  {
    feature: "Communication",
    configKey: "niramaya.featureaccess.sidebaritem.communication",
    roles: ["Volunteer Coordinator", "Volunteer"],
  },
  {
    feature: "Manage Invitation",
    configKey: "niramaya.featureaccess.sidebaritem.invite",
    roles: ["Volunteer Coordinator"],
  },
  {
    feature: "My Team",
    configKey: "niramaya.featureaccess.sidebaritem.workforce",
    roles: ["Volunteer Coordinator"],
  },
  {
    feature: "Patients",
    configKey: "niramaya.featureaccess.sidebaritem.patient",
    roles: ["Volunteer Coordinator"],
  },
  {
    feature: "Form Summary",
    configKey: "niramaya.featureaccess.sidebaritem.forms-summary",
    roles: ["Volunteer Coordinator"],
  },
  {
    feature: "Form Designer",
    configKey: "niramaya.featureaccess.sidebaritem.form-builder",
    roles: ["Volunteer Coordinator"],
  },
  {
    feature: "Audit Logs",
    configKey: "niramaya.featureaccess.sidebaritem.audit-logs",
    roles: ["Volunteer Coordinator"],
  },
  {
    feature: "Reporting Logs",
    configKey: "niramaya.featureaccess.sidebaritem.reporting-logs",
    roles: ["Volunteer Coordinator"],
  },
  {
    feature: "Help Desk",
    configKey: "niramaya.featureaccess.sidebaritem.helpdesk",
    roles: ["Volunteer Coordinator", "Volunteer"],
  },
  {
    feature: "Training",
    configKey: "niramaya.featureaccess.sidebaritem.training",
    roles: ["Volunteer Coordinator", "Volunteer"],
  },
];

export const colorThemeLabels = [
  {
    label: "Primary Color",
    key: "main-theme-color",
  },
  {
    label: "Secondary Color",
    key: "secondary-theme-color",
  },
  {
    label: "Primary Text Color",
    key: "primary-text-color",
  },
  {
    label: "Secondary Text Color",
    key: "secondary-text-color",
  },
  {
    label: "Selected Menuitem Color",
    key: "selected-bg-color",
  },
  {
    label: "Tooltip Text Color",
    key: "tool-tip-text-color",
  },
  {
    label: "Warning Text Color",
    key: "text-warning",
  },
];

export const templatesData = [
  {
    title: "Birthday Template",
    type: "birthday-wish-template",
    templateRequired: [
      {
        label: "Email Subject",
        key: "email_subject",
      },
      {
        label: "Email Body",
        key: "email_body",
      },
      {
        label: "FCM Title",
        key: "fcm_title",
      },
      {
        label: "FCM Body",
        key: "fcm_notification_body",
      },
    ],
  },
  {
    title: "Anniversary Template",
    type: "anniversary-wish-template",
    templateRequired: [
      {
        label: "Email Subject",
        key: "email_subject",
      },
      {
        label: "Email Body",
        key: "email_body",
      },
      {
        label: "FCM Title",
        key: "fcm_title",
      },
      {
        label: "FCM Body",
        key: "fcm_notification_body",
      },
    ],
  },
  {
    title: "Announcement Template",
    type: "announcement",
    templateRequired: [
      {
        label: "Email Subject",
        key: "email_subject",
      },
      {
        label: "Email Body",
        key: "email_body",
      },
      {
        label: "FCM Title",
        key: "fcm_title",
      },
      {
        label: "FCM Body",
        key: "fcm_notification_body",
      },
    ],
  },
  {
    title: "Volunteer Request Assignment",
    type: "careplan_assigned",
    templateRequired: [
      {
        label: "Email Subject",
        key: "email_subject",
      },
      {
        label: "Email Body",
        key: "email_body",
      },
      {
        label: "FCM Title",
        key: "fcm_title",
      },
      {
        label: "FCM Body",
        key: "fcm_notification_body",
      },
    ],
  },
  {
    title: "Patient Updates Template",
    type: "patient_updates",
    templateRequired: [
      {
        label: "Email Subject",
        key: "email_subject",
      },
      {
        label: "Email Body",
        key: "email_body",
      },
      {
        label: "FCM Title",
        key: "fcm_title",
      },
      {
        label: "FCM Body",
        key: "fcm_notification_body",
      },
    ],
  },
  {
    title: "Visit Report Rejection",
    type: "visit_report_rejected",
    templateRequired: [
      {
        label: "Email Subject",
        key: "email_subject",
      },
      {
        label: "Email Body",
        key: "email_body",
      },
      {
        label: "FCM Title",
        key: "fcm_title",
      },
      {
        label: "FCM Body",
        key: "fcm_notification_body",
      },
    ],
  },
  {
    title: "Signup Invitation Template",
    type: "signup_invitation",
    templateRequired: [
      {
        label: "Email Subject",
        key: "email_subject",
      },
      {
        label: "Email Body",
        key: "email_body",
      },
    ],
  },
];

export const defaultForms = [
  {
    formType: "Visit Report",
    configKey: "niramaya.forms.patientvisitreport",
  },
  {
    formType: "Compliance",
    configKey: "niramaya.careplan.compliance.form",
  },
];
